import { useContext } from 'react';
import UserContext from './global_context';

const useRoutePath = () => {

  const context = useContext(UserContext),
        { menu_routes, isLogin, isOnboarding } = context;

  const getBasePath = (key, fromOnboarding = false) => {
    const route_Value = menu_routes.find((el) => {

            if (fromOnboarding) {
              if (el.onboardingKey?.trim()?.toUpperCase() === key?.trim()?.toUpperCase()) {
                return true;
              }
            }
            else {
              if (el.key?.trim()?.toUpperCase() === key?.trim()?.toUpperCase()) {
                return true;
              }
            }

          }),
          { basePath = false } = route_Value || {};
    if (basePath) {
      return basePath;
    }
    else if (isLogin === 'true') {
      return '/dashboard';
    }
    else if (isOnboarding === 'false') {
      return '/login';
    }
    else {
      return '/onboarding';
    }
  };

  return {
    getBasePath,
  };


};

export default useRoutePath;